<template>
  <div class="wrld-container">
    <v-breadcrumbs v-if="breadcrumbs !== undefined" :items="breadcrumbs" class="pb-0">
      <v-icon slot="divider">keyboard_arrow_right</v-icon>
    </v-breadcrumbs>
    <v-container class="pb-0" :fluid="isFluid" v-if="pageIsLoading === false">
      <v-row>
        <v-col sm="12">
          <slot></slot>
        </v-col>
      </v-row>
    </v-container>
    <div class="loading-circle" v-else>
      <v-progress-circular
        :size="60"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wrld-container',
  props: {
    breadcrumbs: Array,
    pageIsLoading: {
      type: Boolean,
      default: false
    },
    isFluid: {
      type: Boolean,
      default: false
    }
  }
}
</script>
